// Animate on arrival without hiding content or delaying access to controls.
export function initPageMotion() {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (preference.matches || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (preference.matches || !entry.target.animate) return;
      const animation = entry.target.animate([
        { opacity: 0.65, transform: 'translateY(10px)' },
        { opacity: 1, transform: 'translateY(0)' },
      ], { duration: 520, easing: 'cubic-bezier(.22, 1, .36, 1)' });
      const cancel = () => { if (preference.matches) animation.cancel(); };
      preference.addEventListener('change', cancel);
      animation.finished.catch(() => {}).finally(() => preference.removeEventListener('change', cancel));
    });
  }, { threshold: 0, rootMargin: '0px 0px 32px 0px' });

  document.querySelectorAll('.ref-dashboard > section, .ref-dashboard-hero, #period-card, #domain-config-card, .hosting-addon-card, .ord-generic-plan-card').forEach(element => observer.observe(element));
}
